// The "hidden_languages" local setting: comma-separated language codes, kept as a
// string so settings sync replaces it as a whole (lists would be merged).
export const parseLanguages = value => new Set((value || "").split(",").map(code => code.trim()).filter(Boolean));

// The "hide_bots" local setting: comma-separated timeline groups in which posts
// and boosts of bot accounts are hidden.
export const BOT_TIMELINE_GROUPS = ["home", "lists", "public", "hashtags", "explore"];

export const botGroupOf = (timelineId) => {
  if (timelineId === "home") {
    return "home";
  }
  if (timelineId.startsWith("list:")) {
    return "lists";
  }
  if (/^(public|community)(:|$)/.test(timelineId)) {
    return "public";
  }
  if (timelineId.startsWith("hashtag:")) {
    return "hashtags";
  }
  if (timelineId === "explore") {
    return "explore";
  }
  return null;
};
